import { render, staticRenderFns } from "./AnswerSelect.vue?vue&type=template&id=4453caf4&"
import script from "./AnswerSelect.vue?vue&type=script&lang=js&"
export * from "./AnswerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports